module.exports = __webpack_public_path__ + "static/media/05- education-reward.59f05d07.png";